/**
 * Pure helpers shared by the Export Settings modal and the new
 * template page-selection modal. Extracted so the two modals share
 * blog detection and slug normalization. (Its `escHtml` was a
 * byte-identical duplicate of `shared/html-escape.js` and was deleted
 * in CB-3 — import `escapeHTML` from there.)
 */

const BLOG_PAGE_PATTERN = /\b(blog|post|article|news)\b/i;

export function slugifyName(name) {
  return String(name || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function looksLikeBlogPage(name) {
  const slug = slugifyName(name);
  if (!slug) return false;
  return (
    slug === 'blog' ||
    slug.startsWith('blog-') ||
    slug.includes('-blog-') ||
    slug.startsWith('post-') ||
    slug.startsWith('article-') ||
    BLOG_PAGE_PATTERN.test(name)
  );
}

/**
 * @param {Array<object>} pages
 * @param {object} [opts]
 * @param {string} [opts.idField='id'] — page-map entries use 'filename'; state.pages use 'id'.
 */
export function normalizePageEntries(pages, { idField = 'id' } = {}) {
  if (!Array.isArray(pages)) return [];
  return pages.map((page, index) => {
    const rawName = page?.name;
    const name =
      typeof rawName === 'string' && rawName.trim() ? rawName.trim() : `Page ${index + 1}`;
    const slug = slugifyName(name);
    const rawId = page?.[idField];
    const id = String(rawId != null && rawId !== '' ? rawId : `page-${index + 1}`);
    return {
      id,
      name,
      slug,
      isHome: index === 0,
      isLikelyBlog: looksLikeBlogPage(name),
      searchText: `${name.toLowerCase()} ${slug}`.trim()
    };
  });
}
